import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNoAuth } from "./axiosInstance";

export const fetchRazorPayStatus = createAsyncThunk(
  "razorPay/fetch",
  async ({
    uuid,
    payment_id,
    order_id,
    isError,
    razorpay_signature,
    errorObj,
  }) => {
    const response = await axiosNoAuth.post(
      "https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/payment_status",
      {
        uid: uuid,
        payment_id: payment_id,
        order_id: order_id,
        isError: isError,
        razorpay_signature: razorpay_signature,
        errorObj: errorObj,
      }
    );
    return response.data;
  }
);

const razorPaySlice = createSlice({
  name: "razorPay",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRazorPayStatus.fulfilled, (state, action) => {
      return action.payload;
    });
  },
});

export const selectRazorPayStatus = (state) =>
  state.personaliseLessons?.razorPay;
export default razorPaySlice.reducer;
